import React from 'react';
import styled from 'styled-components';

import { colors } from 'theme/colors';

import EditSmallIcon from './EditSmall';

import { RichTextInput } from '../TextInput';

export const DetailsContainer = styled.div`
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${colors.ui.border.main};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const EntityText = styled.h4`
  color: ${colors.ui.chip.grayText}
  font: 12px/14px Roboto;
  margin: 0;
  letter-spacing: 0.3px;
`;

export const NameText = styled.h4`
  color: ${({ theme }) => theme.palette.primary.dark};
  font: 18px/24px Roboto;
  font-weight: 500;
  letter-spacing: 0px;
  margin: 0;
  margin-top: 6px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
`;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledEdit = styled(EditSmallIcon)`
  margin-left: 6px;
  align-items: center;
  font-size: 16px;
`;

export const StyledTextInput = styled(RichTextInput)`
  margin-top: 6px;
  width: initial;
  > p {
    font: 18px/24px Roboto;
    font-weight: 500;
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
